import { z } from 'zod';

export type CalculateFestivalEnvDto = z.infer<
  typeof calculateFestivalEnvDtoSchema
>;

const scoreObject = z.object({
  score: z.number(),
  maxScore: z.number(),
});

export const calculateFestivalEnvDtoSchema = z.object({
  score: z.number(),
  maxScore: z.number(),
  topics: z.object({
    GLOBAL_CO2: z.object({
      score: z.number(),
      maxScore: z.number(),
      sections: z.object({
        CO2: scoreObject,
      }),
    }),
    FOOD_BEVERAGES: z.object({
      score: z.number(),
      maxScore: z.number(),
      sections: z.object({
        CATERING: scoreObject,
        BEVERAGES: scoreObject,
        DISHES: scoreObject,
      }),
    }),
    RESOURCES_POLLUTION: z.object({
      score: z.number(),
      maxScore: z.number(),
      sections: z.object({
        WATER: scoreObject,
        ENERGY: scoreObject,
        WASTE_ECODESIGN: scoreObject,
        POLLUTION_LOCATION: scoreObject,
      }),
    }),
    COMMUNICATION: z.object({
      score: z.number(),
      maxScore: z.number(),
      sections: z.object({
        PHYSICAL_COMMUNICATION: scoreObject,
        DIGITAL_COMMUNICATION: scoreObject,
      }),
    }),
    PUBLIC_ENGAGEMENT: z.object({
      score: z.number(),
      maxScore: z.number(),
      sections: z.object({
        MOBILITY_STRATEGY: scoreObject,
        PUBLIC_INFORMATION: scoreObject,
      }),
    }),
  }),
  sectors: z.object({
    artists: z.object({
      score: z.number(),
      maxScore: z.number(),
    }),
    public: z.object({
      score: z.number(),
      maxScore: z.number(),
    }),
    site: z.object({
      score: z.number(),
      maxScore: z.number(),
    }),
    team: z.object({
      score: z.number(),
      maxScore: z.number(),
    }),
  }),
});
